import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { FxTranslate } from '../../core/translate';
import { IPais, IRegion } from '../../services/api/entity/model';
import { ICardEdit } from '../../services/operaciones/model/ICardEdit';
import styles from './card-content.module.scss';
import { ICardSeccion, Secciones } from './index.service';
import CardSeccionComisiones from './seccion/comisiones.seccion';
import CardSeccionConciliacion from './seccion/conciliacion.seccion';
import CardSeccionContacto from './seccion/contacto.seccion';
import CardSeccionCotizacion from './seccion/cotizacion.seccion';
import CardSeccionFacturacion from './seccion/facturacion.seccion';
import CardSeccionOperacion from './seccion/operacion.seccion';
import CardSeccionPago from './seccion/pago.seccion';
import CardSeccionPasajeros from './seccion/pasajeros.seccion';
import CardSeccionProducto from './seccion/producto.seccion';
import CardSeccionSeguimiento from './seccion/seguimiento.seccion';
import CardSeccionVouchers from './seccion/vouchers.seccion';
import CardSeccionDevoluciones from './seccion/devoluciones.seccion';
import { UsuarioComboItem } from '../../model/seguridad';
import { MonedaComboItem } from '../../model/cobranza';

export type ISubMedioPago = {
  id?: number;
  nombre?: string;
  idmediopago?: number;
}

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  data?: ICardEdit | null | undefined;

  secciones?: ICardSeccion[];
  selected?: ICardSeccion;

  //Maestros
  paises?: IPais[] | null | undefined;
  regiones?: IRegion[] | null | undefined;
  monedas?: MonedaComboItem[] | null | undefined;
  submediospago?: ISubMedioPago[] | null | undefined;
  usuarios?: UsuarioComboItem[] | null | undefined;

  onUpdateFields: (updates: { field: string, value: any }[]) => void;
}

function BoardCardFormContent({ storage, t,
  data,
  secciones, selected,
  paises, regiones, monedas, submediospago, usuarios,
  onUpdateFields
} : IProps) {
  const show = (sec: Secciones) => (!selected || sec === selected.id) && !!secciones?.find(p => p.id === sec);

  return <div className={styles["card-content-content"]}>
    {show(Secciones.Operacion) && <CardSeccionOperacion t={t} data={data} monedas={monedas} paises={paises} onUpdateFields={onUpdateFields} />}
    {show(Secciones.Cotizacion) && <CardSeccionCotizacion t={t} data={data} paises={paises} regiones={regiones} onUpdateFields={onUpdateFields} />}
    {show(Secciones.Producto) && <CardSeccionProducto t={t} data={data} monedas={monedas} onUpdateFields={onUpdateFields} />}
    {show(Secciones.Pasajeros) && <CardSeccionPasajeros t={t} data={data} onUpdateFields={onUpdateFields} />}
    {show(Secciones.Contacto) && <CardSeccionContacto t={t} data={data} onUpdateFields={onUpdateFields} />}
    {show(Secciones.Pago) && <CardSeccionPago t={t} data={data} submediospago={submediospago} monedas={monedas} usuarios={usuarios} onUpdateFields={onUpdateFields} />}
    {show(Secciones.Vouchers) && <CardSeccionVouchers t={t} data={data} onUpdateFields={onUpdateFields} />}
    {show(Secciones.Facturacion) && <CardSeccionFacturacion t={t} data={data} onUpdateFields={onUpdateFields} />}
    {show(Secciones.Conciliacion) && <CardSeccionConciliacion t={t} data={data} monedas={monedas} onUpdateFields={onUpdateFields} />}
    {show(Secciones.Comisiones) && <CardSeccionComisiones t={t} data={data} onUpdateFields={onUpdateFields} />}
    {show(Secciones.Devoluciones) && <CardSeccionDevoluciones t={t} data={data} onUpdateFields={onUpdateFields} />}
    {show(Secciones.Seguimiento) && <CardSeccionSeguimiento t={t} data={data} onUpdateFields={onUpdateFields} />}
  </div>;
}


export default connect((s:any) => ({ storage:s.main }))(BoardCardFormContent);
